import { emailValidation, stringValidation } from './base'
import { validator } from './core'

export const LoginWithEmailAndPasswordSchema = validator.object().shape({
  email: emailValidation(),
  password: stringValidation('Password'),
})
